import {Pipe, PipeTransform} from '@angular/core';
import {Human, HumanNameStyle} from '../../models/human';

@Pipe({name: 'humanName'})
export class HumanNamePipe implements PipeTransform {
    transform(input: any, style: HumanNameStyle = 'lastNameFirst', nameFieldPrefix: string = ''): string {
        return Human.getName(input, style, nameFieldPrefix);
    }
}
